/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

/*globals Tc */

/**
 * List of available placeholders in the component
 */
var PLACEHOLDERS = {
	familyName: 'familyName'
};

/**
 * Selectors of placeholder aware elements which can contain placeholders
 */
var PLACEHOLDER_AWARE_ELEMENTS = [
	'.tracking'
];

/**
 * Attributes of placeholder aware elements, which can contain placeholders
 */
var PLACEHOLDER_AWARE_ATTRIBUTES = [
	'data-tracking-friendlyname',
	'data-tracking-location',
	'data-tracking-action',
	'data-tracking-label',
	'data-tracking-category',
	'data-tracking-conversionid',
	'data-tracking-conversionsubject'
];

var ORIGIN_URL_TEMPLATE = '##ORIGIN_URL##';

var HASH_SUFFIX = 'retention';

/**
 * @namespace Tc.Module
 * @class RetentionButton
 * @extends Tc.Module
 */
Tc.Module.RetentionButton = Tc.Module.extend({

	on: function (callback) {
		var mod = this;
		mod.loginUrl = mod.$ctx.data('login-url');
		// HOTFIX: Minimal impact change to replace former server side url, with encoded clientside url.
		mod.originUrl = encodeURIComponent(window.location.href.replace(/\(.*\)/,"").replace(/\.html.+/,".html"));

		callback();
	},

	after: function () {
		var mod = this;

		require('lib/personalization/profile').getProfile().then(function(profile) {
			mod.profile = profile;
			mod.button = mod.$ctx.find('a');
			mod.button.on('click', $.proxy(mod.handleClick, mod));
			mod.updatePlaceholders({});
			mod.onStartProductDataSubscription();
			mod.updateLoginUrl();

			if(profile.getUser()) {
				// if we return from a login, make sure the retention display is shown.
				mod.selectRetentionModelFilter();
			}
		});

	},

	updateLoginUrl: function (info) {
		var mod = this,
			url,
			ch = '#',
			pageUrl = mod.originUrl;

		if (!mod.loginUrl || !pageUrl) {
			return;
		}

		//get origin url from info
		if (info && info.deeplink && info.deeplink.length > 0) {
			mod.deeplink = info.deeplink;
		}

		if (mod.deeplink) {
			pageUrl = pageUrl.replace('.html', mod.deeplink + '.html');
		}

		if (pageUrl.indexOf('#') > -1) {
			ch = '&';
		}

		url = mod.loginUrl.replace(ORIGIN_URL_TEMPLATE, encodeURIComponent(pageUrl + ch + HASH_SUFFIX));

		mod.button.attr('href', url);
		mod.button.data('placeholder-template-href', url);
	},

	/**
	 * Channel listener to register for EcommerceProductDataHub events.
	 *
	 * @method onStartProductDataSubscription
	 * @return void
	 */
	onStartProductDataSubscription: function () {
		var mod = this,
			initialChannel = 'EcommerceProductDataHub';

		mod.sandbox.subscribe(initialChannel, mod);
		mod.fire('subscribeForProductData', {
			element: mod.$ctx,
			subscribe: function (channel, fetchDataOnSubscribe) {
				mod.productDataChannel = channel;
				mod.sandbox.unsubscribe(initialChannel, mod);
				mod.sandbox.subscribe(channel, mod);
				mod.$ctx.removeClass('initializing');

				// If component was lazy loaded, request initialization data
				// from data hub.
				if (fetchDataOnSubscribe) {
					mod.fire('getInfo', {
						callback: function (data) {
							mod.onInvalidateProductData({info: data});
						}
					}, [mod.productDataChannel]);
				}
			}
		}, [initialChannel]);
	},

	/**
	 * Channel listener which gets called by EcommerceProductDataHub to notify about data changes.
	 *
	 * @method onInvalidateProductData
	 * @param {Object} data See EcommerceProductDataHub for details about the structure
	 * @return void
	 */
	onInvalidateProductData: function (data) {
		var mod = this, status = {};
		if (mod.productDataChannel) {
			if (mod.subscriptionId) {
				status.subscriptionId = mod.subscriptionId;
			}

			//don't wait getInfo
			mod.updateLoginUrl(data.info);

			// request the new data based on the settings in this component
			mod.fire('getInfo', {
				status: status,
				callback: $.proxy(mod.getInfoCallback, mod)
			}, [mod.productDataChannel]);
		}
	},

	/**
	 * Callback function which gets passed as a parameter to the [GetInfo] channel event.
	 *
	 * Creates all required placeholders and initiates the placeholder replacement in the component.
	 *
	 * @method getInfoCallback
	 * @param {Object} data See EcommerceProductDataHub for details about the structure
	 * @return void
	 */
	getInfoCallback: function (data) {
		var mod = this, placeholders = {};
		if (data.family) {
			placeholders[PLACEHOLDERS.familyName] = data.family.getFamilyName();
		}
		mod.updatePlaceholders(placeholders);
	},

	/**
	 * Updates the placeholders in the component.
	 *
	 * @method updatePlaceholders
	 * @param {Map/Object} placeholders A map of key value pairs
	 * @return void
	 */
	updatePlaceholders: function (placeholders) {
		var mod = this, element, elementText, attrValue,
			elements = $(PLACEHOLDER_AWARE_ELEMENTS.join(', '), mod.$ctx),
			attributes = PLACEHOLDER_AWARE_ATTRIBUTES;
		elements.each(function () {
			element = $(this);

			// replace in text nodes
			elementText = element.data('placeholder-template');
			if (!elementText) {
				elementText = element.text();
				element.data('placeholder-template', elementText);
			}
			element.text(mod.replacePlaceholders(elementText, placeholders));

			// replace in attributes
			for (var j = 0; j < attributes.length; j++) {
				attrValue = element.data('placeholder-template-' + attributes[j]);
				if (!attrValue) {
					attrValue = element.attr(attributes[j]);
					element.data('placeholder-template-' + attributes[j], attrValue);
				}
				if (attrValue) {
					attrValue = mod.replacePlaceholders(attrValue, placeholders);
					element.attr(attributes[j], attrValue);
					if (attributes[j].indexOf('data-') === 0) {
						element.data(attributes[j].substring(5), attrValue);
					}
				}
			}
		});
	},

	/**
	 * Replaces all placeholders in the given source string.
	 * Not existing placeholders are replaced by empty strings.
	 *
	 * @method replacePlaceholders
	 * @param {String} source The source string
	 * @param {Map/Object} placeholders A map of key value pairs
	 * @return {String} the given source string with replaced placeholders.
	 */
	replacePlaceholders: function (source, placeholders) {
		var foundPlaceholders, i, placeholderName;
		if (source) {
			foundPlaceholders = source.match(/\$\{[a-zA-Z0-9]+\}/g);
			for (i = 0; foundPlaceholders && i < foundPlaceholders.length; i++) {
				placeholderName = foundPlaceholders[i].substring(0, foundPlaceholders[i].length - 1).substring(2);
				source = source.replace(new RegExp('\\$\\{' + placeholderName + '\\}', 'g'), placeholders[placeholderName] || '');
			}
		}
		return source;
	},

	trackingEnabled: function (tracking) {
		return $(tracking).data('tracking-enabled');
	},

	/**
	 * Perform the tracking when the component became visible
	 */
	trackButtonClick: function () {
		var mod = this,
			$tracking = mod.$ctx.find('.tracking');

		if (mod.trackingEnabled($tracking)) {
			mod.log('Tc.Module.RetentionButton > trackButtonClick');
			SCS.portal.datalayer.trackEvent(
				$tracking.data('tracking-action'),
				$tracking.data('tracking-label'),
				$tracking.data('tracking-location'),
				$tracking.data('tracking-category'),
				$tracking.data('tracking-friendlyname'));

			SCS.portal.datalayer.trackConversion(
				$tracking.data('tracking-conversionid'),
				$tracking.data('tracking-conversionsubject')
			);
		}
	},

	selectRetentionModelFilter: function(){
		// just set the product model filter subscriptionId (desktop) oder subscriptionType (mobile) to the value retention
		if ($('select[name=filter-subscriptionId]').length) {
			$('select[name=filter-subscriptionId]').val('retention').trigger('change');
		}
		else {
			$('li[data-name=filter-subscriptionType][data-value=retention]').find('a').click();
		}
	},

	handleClick: function (event) {
		var mod = this;
		mod.trackButtonClick();

		if (!mod.profile.getUser()) {
			// just go to login. so do nothing here.
			return;
		}

		event.stopImmediatePropagation();
		event.preventDefault();
		mod.selectRetentionModelFilter();
		mod.fire('retentionButtonClick');
	}
});


}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/ecommerce/clientlibs/shared/js/modules/Tc.Module.RetentionButton.js
// module id = 256
// module chunks = 0